module.exports = __webpack_public_path__ + "assets/img/17_1091_big.0580a16f.jpg";